export default __webpack_public_path__ + "static/media/23b.1974f895.png";